import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  notFound: {
    id: 't.notFound',
    defaultMessage: 'NOT FOUND',
  },
  pageNotFound: {
    id: 't.pageNotFound',
    defaultMessage: 'Page Not Found',
  },
  pageNotAvailable: {
    id: 't.pageNotAvailable',
    defaultMessage: "SORRY - You've reached this page in error!",
  },
  notFoundInfo: {
    id: 't.notFoundInfo',
    defaultMessage: "The page you're looking for may have been moved, updated, or deleted",
  },
  notAvailableInfo: {
    id: 't.notAvailableInfo',
    defaultMessage:
      'Pandora Ad-Free Weekends and Special Curated SiriusXM Entertainment is redeemable only through your mobile device.',
  },
  notAvailableOptions: {
    id: 't.notAvailableOptions',
    defaultMessage:
      'Once redeemed, you can access this special content on other devices. Please note this offer may not be available on all consumer devices or products. For more information, please see the {url}.',
  },
  notAvailableTag: {
    id: 't.notAvailableTag',
    defaultMessage:
      'Offer Terms for T-Mobile: Pandora Ad-Free Radio Weekends and Special Curated SiriusXM Entertainment',
  },
  notAvailableFarewell: {
    id: 't.notAvailableFarewell',
    defaultMessage: 'Wishing you well and enjoy your T-Mobile Pandora Ad-Free Weekend experience!',
  },
  tryOneOfTheseOptions: {
    id: 't.tryOneOfTheseOptions',
    defaultMessage: 'Try one of these options instead:',
  },
  goBackToTheMusic: {
    id: 't.goBackToTheMusic',
    defaultMessage: 'Go back to the music',
  },
  myCollection: {
    id: 't.myCollection',
    defaultMessage: 'My Collection',
  },
  browse: {
    id: 't.browse',
    defaultMessage: 'Browse',
  },
  browseGenres: {
    id: 't.browseGenres',
    defaultMessage: 'Browse Genres',
  },
  contactSupport: {
    id: 't.contactSupport',
    defaultMessage: 'Contact Support',
  },
  podcastInfo: {
    id: 't.podcastInfo',
    defaultMessage:
      'Discover the world of podcasts\u000Aon the Pandora mobile app.\u000AComing soon to web!',
  },
  getAppOnAppStore: {
    id: 't.getAppOnAppStore',
    defaultMessage: 'Available on the app store',
  },
  getAppOnPlayStore: {
    id: 't.getAppOnPlayStore',
    defaultMessage: 'Android app on google play',
  },
  continueToMusic: {
    id: 't.continueToMusic',
    defaultMessage: 'Continue To Music',
  },
} as const);
